import { DataModel } from "common/models/utility-models/base-model"

export class TrainersStudentModel extends DataModel {
    first_name: any = ''
    last_name: any = ''
    email: any = ''
    mobile_number: any = ''
    category_id: any = ''
    trainer_id: any = '';
  }